"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER = exports.CONTACT = exports.MARKETING_CONTACT = void 0;
var MARKETING_CONTACT = 'marketing contact';
exports.MARKETING_CONTACT = MARKETING_CONTACT;
var CONTACT = 'contact';
exports.CONTACT = CONTACT;
var USER = 'user';
exports.USER = USER;